import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-page-v2',
  templateUrl: './home-page-v2.component.html',
  styleUrls: ['./home-page-v2.component.scss']
})
export class HomePageV2Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
